"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CarouselArrowRight = function CarouselArrowRight(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.82 57.93",
    width: "10.82",
    height: "57.93",
    fill: "#024965"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.08,59a2.5,2.5,0,0,1-2.45-3l5.55-25.79L5.48,4.07A2.5,2.5,0,0,1,10.37,3l5.82,26.6a2.5,2.5,0,0,1,0,1.06L10.52,57A2.5,2.5,0,0,1,8.08,59Z",
    transform: "translate(-5.42 -1.04)"
  }));
};

var _default = CarouselArrowRight;
exports["default"] = _default;